// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__EPTET","container":"styles_container__3VE7m","title":"styles_title__15Mme","wrapper":"styles_wrapper__3ztCR","answer":"styles_answer__P7gJ0"};